import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'

import { EditIcon } from '@/assets/icons/icons.jsx'
import Button from '@/components/button/Button.jsx'
import SectionItem from '@/components/sidebar-tab-item/section-item/SectionItem'
import SectionTitle from '@/components/sidebar-tab-item/section-title/SectionTitle'
import {
    StyledSliderSectionContainer,
    StyledTabInfoContainer,
    StyledSidebarSubHeader,
    StyledTabCtaContainer,
} from '@/components/sidebar-tab-item/styles'
import { LABELS_TABLES } from '@/utilities/constants/index.js'

import { balanceFields } from './balanceFields'

const BalanceSidebar = ({ data, setDataForm }) => {
    const { t } = useTranslation()
    const theme = useTheme()

    const project = balanceFields(data)

    return (
        <>
            <StyledSidebarSubHeader>
                {
                    <h3>
                        {data?.name} #{data?.global_project_id}
                    </h3>
                }
                <StyledTabCtaContainer>
                    <Button
                        onClick={() =>
                            setDataForm({
                                isOpen: true,
                                typeForm: LABELS_TABLES.final_balance,
                                id: data?.id,
                                isEdit: true,
                                data: data,
                            })
                        }
                        collapsed
                    >
                        <EditIcon
                            width={10}
                            height={10}
                            fill={theme.palette.neutral.base[0]}
                        />
                    </Button>
                </StyledTabCtaContainer>
            </StyledSidebarSubHeader>
            <StyledSliderSectionContainer>
                <StyledTabInfoContainer>
                    <SectionItem
                        label={t('general.project')}
                        value={data?.name}
                        width={100}
                    />
                </StyledTabInfoContainer>
            </StyledSliderSectionContainer>

            <StyledSliderSectionContainer>
                <SectionTitle title={t('project.sidebar_left.info')} />
                <StyledTabInfoContainer>
                    {project.info.map((item, index) => {
                        return (
                            <SectionItem
                                label={item.label}
                                value={item.value}
                                width={item.width}
                                key={index}
                            />
                        )
                    })}
                </StyledTabInfoContainer>
            </StyledSliderSectionContainer>

            <StyledSliderSectionContainer>
                <SectionTitle title={t('project.sidebar_left.reporting')} />

                <StyledTabInfoContainer>
                    {project.reporting.map((item, index) => {
                        return (
                            <SectionItem
                                label={item.label}
                                value={item.value}
                                width={item.width}
                                key={index}
                            />
                        )
                    })}
                </StyledTabInfoContainer>
            </StyledSliderSectionContainer>

            <StyledSliderSectionContainer>
                <SectionTitle title={t('project.sidebar_left.link')} />

                <StyledTabInfoContainer>
                    {project.link.map((item, index) => {
                        return (
                            <SectionItem
                                label={item.label}
                                value={item.value}
                                width={item.width}
                                link={item?.link}
                                key={index}
                            />
                        )
                    })}
                </StyledTabInfoContainer>
            </StyledSliderSectionContainer>

            <div>
                <SectionTitle title={t('general.team')} />

                <StyledTabInfoContainer>
                    {project.team.map((item, index) => {
                        return (
                            <SectionItem
                                label={item.label}
                                value={item.value}
                                width={item.width}
                                key={index}
                            />
                        )
                    })}
                    {/* {teamData?.users?.map((item, index) => {
                        return (
                            <SectionItem
                                label={t('project.sidebar_left.labels.members')}
                                value={item?.full_name}
                                width={100}
                                key={index}
                            />
                        )
                    })}*/}
                </StyledTabInfoContainer>
            </div>
        </>
    )
}

export default BalanceSidebar

BalanceSidebar.propTypes = {
    data: PropTypes.any,
    setDataForm: PropTypes.func,
}
